import { Alert, Button} from "antd";
import { Link } from "react-router-dom";

function AdminConsultationsHint({ consultationsCount }) {
  if (!consultationsCount) return null;
  return (
    <Alert
      message="درخواست مشاوره"
      description={`${consultationsCount} درخواست جدید برای مشاوره ثبت شده است.`}
      type="info"
      banner
      style={{ width: "100%", marginBottom: "30px" }}
       action={
          <Button size="small" type="pramary">
            <Link to="/admin-consultations/new">بررسی</Link>
          </Button>
        }
    />
  );
}

export default AdminConsultationsHint;
